import React, { useRef } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import Box from '../../../components/Common/Box';
import ChartShareButton from '../../../components/Common/ChartShareButton';

interface Asset {
  symbole: string;
  valeur_actuelle: number;
}

interface AssetAllocationProps {
  assets: Asset[];
}

const COLORS = [
  '#0088FE',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#8884d8',
  '#82ca9d',
  '#ffc658',
  '#8dd1e1',
];

const AssetAllocation: React.FC<AssetAllocationProps> = ({ assets }) => {
  const chartRef = useRef<HTMLDivElement>(null);
  // Prepare data: Top 5 + Others
  const sortedAssets = [...assets].sort((a, b) => b.valeur_actuelle - a.valeur_actuelle);
  let chartData = sortedAssets;

  if (sortedAssets.length > 5) {
    const top5 = sortedAssets.slice(0, 5);
    const othersValue = sortedAssets.slice(5).reduce((sum, a) => sum + a.valeur_actuelle, 0);
    chartData = [...top5, { symbole: 'Autres', valeur_actuelle: othersValue }];
  }

  const data = chartData.map((a) => ({
    name: a.symbole,
    value: a.valeur_actuelle,
  }));

  return (
    <Box>
      <div style={{ padding: '20px', position: 'relative' }} ref={chartRef}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3
            style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', color: 'var(--text-heading)' }}
          >
            Répartition du Portefeuille
          </h3>
          <ChartShareButton
            targetRef={chartRef}
            fileName="repartition_portefeuille"
          />
        </div>
        <div style={{ height: '300px', width: '100%' }}>
          <ResponsiveContainer width='100%' height='100%'>
            <PieChart>
              <Pie
                data={data}
                cx='50%'
                cy='50%'
                innerRadius={60}
                outerRadius={80}
                fill='#8884d8'
                paddingAngle={5}
                dataKey='value'
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip
                formatter={(value: number) => [`${value.toLocaleString()} FCFA`, 'Valeur']}
                contentStyle={{
                  borderRadius: '8px',
                  border: 'none',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                }}
              />
              <Legend verticalAlign='bottom' height={36} iconType='circle' />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </Box>
  );
};

export default AssetAllocation;
